export const isAdminPortalTicket = (application, ticket) => {
    return application === 'admin-portal' && !('haulerID' in ticket);
};
// Type guard to verify application type
export const isSupportedApplication = (app) => {
    return app === 'wayste' || app === 'admin-portal';
};
//# sourceMappingURL=utils.js.map